'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var round = require('lodash/round');
var React = require('react');
var qs = require('qs');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var round__default = /*#__PURE__*/_interopDefaultLegacy(round);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var qs__default = /*#__PURE__*/_interopDefaultLegacy(qs);

var calculateAnnualPercentDiscount = function calculateAnnualPercentDiscount(monthlyPrice, annualPrice) {
  var annualizedMonthlyCost = monthlyPrice * 12;
  var discountRatio = (annualizedMonthlyCost - annualPrice) / annualizedMonthlyCost;
  return round__default['default'](discountRatio * 100);
};

var capitalize = function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

var userIcon = function userIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Edit Profile",
    icon: "M19.996 19.55v.004A10.97 10.97 0 0 1 12 23a10.97 10.97 0 0 1-7.997-3.447A.003.003 0 0 0 4 19.55h.001L4 19.549V18c0-2.66 5.33-4 8-4s8 1.34 8 4v1.548c0 .001 0 .002-.002.002zM12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Edit Profile"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19.996 19.55v.004A10.97 10.97 0 0 1 12 23a10.97 10.97 0 0 1-7.997-3.447A.003.003 0 0 0 4 19.55h.001L4 19.549V18c0-2.66 5.33-4 8-4s8 1.34 8 4v1.548c0 .001 0 .002-.002.002zM12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z",
    fill: color
  }));
};
var envelopeIcon = function envelopeIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Manage Newsletters",
    icon: "M18 5.5H6a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3zm2 2.75l-6.94 4.338a2 2 0 0 1-2.12 0L4 8.25v-.196a1 1 0 0 1 1.53-.848l5.94 3.713a1 1 0 0 0 1.06 0l5.94-3.713a1 1 0 0 1 1.53.848v.196z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Manage Newsletters"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M18 5.5H6a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3zm2 2.75l-6.94 4.338a2 2 0 0 1-2.12 0L4 8.25v-.196a1 1 0 0 1 1.53-.848l5.94 3.713a1 1 0 0 0 1.06 0l5.94-3.713a1 1 0 0 1 1.53.848v.196z",
    fill: color
  }));
};
var refreshIcon = function refreshIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Manage Subscription",
    icon: "M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78l-2.366 2.366a.5.5 0 0 0 .353.854H20V5.207a.5.5 0 0 0-.854-.353L17.65 6.35z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Manage Subscription"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78l-2.366 2.366a.5.5 0 0 0 .353.854H20V5.207a.5.5 0 0 0-.854-.353L17.65 6.35z",
    fill: color
  }));
};
var questionMarkIcon = function questionMarkIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Help",
    icon: "M16.5 8.799c0 .418-.05.785-.152 1.102a3.296 3.296 0 0 1-.427.873 4.315 4.315 0 0 1-.665.75c-.26.235-.554.479-.883.732-.203.165-.37.31-.504.437a1.728 1.728 0 0 0-.313.39c-.076.132-.13.272-.162.417-.031.146-.047.32-.047.523a.494.494 0 0 1-.494.493h-1.748a.722.722 0 0 1-.721-.721c0-.33.031-.624.095-.884a2.62 2.62 0 0 1 .285-.712 3.82 3.82 0 0 1 .465-.627 7.02 7.02 0 0 1 .655-.627l.627-.588c.215-.19.399-.39.551-.599.152-.209.228-.459.228-.75 0-.405-.124-.728-.37-.969-.247-.24-.586-.36-1.017-.36-.532 0-.93.18-1.196.54a1.89 1.89 0 0 0-.24.479 1 1 0 0 1-1.047.656l-1.043-.112a1 1 0 0 1-.852-1.281 3.73 3.73 0 0 1 .247-.644 3.99 3.99 0 0 1 1.054-1.291c.43-.342.918-.599 1.463-.77A5.738 5.738 0 0 1 12.017 5c.57 0 1.124.073 1.662.218a4.236 4.236 0 0 1 1.434.684c.418.31.754.706 1.007 1.187.253.482.38 1.051.38 1.71zm-2.773 8.396c0 .506-.178.934-.532 1.282a1.798 1.798 0 0 1-1.31.522 1.9 1.9 0 0 1-.713-.133 1.81 1.81 0 0 1-.589-.38 1.919 1.919 0 0 1-.408-.57 1.742 1.742 0 0 1-.01-1.396c.095-.221.228-.414.4-.579a1.916 1.916 0 0 1 1.32-.532c.253 0 .49.048.712.143.221.095.417.221.588.38a1.742 1.742 0 0 1 .541 1.263z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Help"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16.5 8.799c0 .418-.05.785-.152 1.102a3.296 3.296 0 0 1-.427.873 4.315 4.315 0 0 1-.665.75c-.26.235-.554.479-.883.732-.203.165-.37.31-.504.437a1.728 1.728 0 0 0-.313.39c-.076.132-.13.272-.162.417-.031.146-.047.32-.047.523a.494.494 0 0 1-.494.493h-1.748a.722.722 0 0 1-.721-.721c0-.33.031-.624.095-.884a2.62 2.62 0 0 1 .285-.712 3.82 3.82 0 0 1 .465-.627 7.02 7.02 0 0 1 .655-.627l.627-.588c.215-.19.399-.39.551-.599.152-.209.228-.459.228-.75 0-.405-.124-.728-.37-.969-.247-.24-.586-.36-1.017-.36-.532 0-.93.18-1.196.54a1.89 1.89 0 0 0-.24.479 1 1 0 0 1-1.047.656l-1.043-.112a1 1 0 0 1-.852-1.281 3.73 3.73 0 0 1 .247-.644 3.99 3.99 0 0 1 1.054-1.291c.43-.342.918-.599 1.463-.77A5.738 5.738 0 0 1 12.017 5c.57 0 1.124.073 1.662.218a4.236 4.236 0 0 1 1.434.684c.418.31.754.706 1.007 1.187.253.482.38 1.051.38 1.71zm-2.773 8.396c0 .506-.178.934-.532 1.282a1.798 1.798 0 0 1-1.31.522 1.9 1.9 0 0 1-.713-.133 1.81 1.81 0 0 1-.589-.38 1.919 1.919 0 0 1-.408-.57 1.742 1.742 0 0 1-.01-1.396c.095-.221.228-.414.4-.579a1.916 1.916 0 0 1 1.32-.532c.253 0 .49.048.712.143.221.095.417.221.588.38a1.742 1.742 0 0 1 .541 1.263z",
    fill: color
  }));
};
var logoutIcon = function logoutIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Log Out",
    icon: "M10.795 16.295c.39.39 1.02.39 1.41 0l3.588-3.588a1 1 0 0 0 0-1.414l-3.588-3.588a.999.999 0 0 0-1.411 1.411L12.67 11H5a1 1 0 1 0 0 2h7.67l-1.876 1.884a.999.999 0 0 0 .001 1.411zM4 7v2h2V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2H4v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Log Out"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M10.795 16.295c.39.39 1.02.39 1.41 0l3.588-3.588a1 1 0 0 0 0-1.414l-3.588-3.588a.999.999 0 0 0-1.411 1.411L12.67 11H5a1 1 0 1 0 0 2h7.67l-1.876 1.884a.999.999 0 0 0 .001 1.411zM4 7v2h2V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2H4v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3z",
    fill: color
  }));
};
var editIcon = function editIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Edit",
    icon: "M16.75 11L13 7.25l-9 9V20h3.75l9-9zm2.96-2.96a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0L14 6.25 17.75 10l1.96-1.96z",
    color: color,
    width: "24px",
    cursor: "pointer",
    display: "block",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Edit"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16.75 11L13 7.25l-9 9V20h3.75l9-9zm2.96-2.96a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0L14 6.25 17.75 10l1.96-1.96z",
    fill: color
  }));
};
var trashIcon = function trashIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Delete Account",
    icon: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Delete Account"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z",
    fill: color
  }));
};
var switchPlan = function switchPlan(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Switch Plan",
    icon: "M4.74 13.358a1 1 0 0 1 1.86-.405l1.438 2.49 5.687-3.284a1 1 0 0 1 1 1.732l-5.687 3.284 1.437 2.489a1 1 0 0 1-1.28 1.41l-4.33-1.975a1 1 0 0 1-.58-1.005l.454-4.736zM19.136 4.9a1 1 0 0 1 .58 1.005l-.455 4.736a1 1 0 0 1-1.861.405l-1.437-2.49-5.689 3.285a1 1 0 0 1-1-1.732l5.689-3.285-1.437-2.489a1 1 0 0 1 1.28-1.41l4.33 1.975z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Switch Plan"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M4.74 13.358a1 1 0 0 1 1.86-.405l1.438 2.49 5.687-3.284a1 1 0 0 1 1 1.732l-5.687 3.284 1.437 2.489a1 1 0 0 1-1.28 1.41l-4.33-1.975a1 1 0 0 1-.58-1.005l.454-4.736zM19.136 4.9a1 1 0 0 1 .58 1.005l-.455 4.736a1 1 0 0 1-1.861.405l-1.437-2.49-5.689 3.285a1 1 0 0 1-1-1.732l5.689-3.285-1.437-2.489a1 1 0 0 1 1.28-1.41l4.33 1.975z",
    fill: color
  }));
};
var paymentMethod = function paymentMethod(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Update Payment Method",
    icon: "M6 5h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6zM5 9h14v3H5V9zm10 5h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Update Payment Method"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6 5h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6zM5 9h14v3H5V9zm10 5h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2z",
    fill: color
  }));
};
var closeIcon = function closeIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Stop Subscribing",
    icon: "M16.936 18.361L12 13.425l-4.936 4.936a1.008 1.008 0 1 1-1.425-1.425L10.575 12 5.639 7.064A1.008 1.008 0 1 1 7.064 5.64L12 10.575l4.936-4.936a1.008 1.008 0 1 1 1.425 1.425L13.425 12l4.936 4.936a1.008 1.008 0 1 1-1.425 1.425z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Stop Subscribing"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16.936 18.361L12 13.425l-4.936 4.936a1.008 1.008 0 1 1-1.425-1.425L10.575 12 5.639 7.064A1.008 1.008 0 1 1 7.064 5.64L12 10.575l4.936-4.936a1.008 1.008 0 1 1 1.425 1.425L13.425 12l4.936 4.936a1.008 1.008 0 1 1-1.425 1.425z",
    fill: color
  }));
};
var backIcon = function backIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Back",
    icon: "M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z",
    color: color,
    width: "24px",
    classes: "Menu-Tray-Header-Nav",
    cursor: "pointer",
    display: "block",
    className: "Menu-Tray-Header-Nav clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Back"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z",
    fill: color
  }));
};
var picoIcon = function picoIcon() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Pico",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#834eff",
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Pico"), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#834eff",
    d: "M0 0h1024v1024h-1024v-1024z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#fff",
    d: "M547.055 85.333h-461.721v853.333h853.333v-853.333h-391.612zM868.557 155.399v663.537l-321.502-321.458v-342.079h321.502zM155.443 155.399h321.576v321.547h-321.576v-321.547zM155.443 547.011h342.034l321.502 321.547h-663.537v-321.547z"
  }));
};
var keepIcon = function keepIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Keep Subscription",
    icon: "M6.36 6.35A7.958 7.958 0 0 1 12.01 4C16.43 4 20 7.58 20 12s-3.57 8-7.99 8c-3.73 0-6.84-2.55-7.73-6h2.08c.82 2.33 3.04 4 5.65 4 3.31 0 6-2.69 6-6s-2.69-6-6-6c-1.66 0-3.14.69-4.22 1.78l2.366 2.366a.5.5 0 0 1-.353.854H4.01V5.207a.5.5 0 0 1 .854-.353L6.36 6.35z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Keep Subscription"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6.36 6.35A7.958 7.958 0 0 1 12.01 4C16.43 4 20 7.58 20 12s-3.57 8-7.99 8c-3.73 0-6.84-2.55-7.73-6h2.08c.82 2.33 3.04 4 5.65 4 3.31 0 6-2.69 6-6s-2.69-6-6-6c-1.66 0-3.14.69-4.22 1.78l2.366 2.366a.5.5 0 0 1-.353.854H4.01V5.207a.5.5 0 0 1 .854-.353L6.36 6.35z",
    fill: color
  }));
};
var giftIcon = function giftIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Gift a Subscription",
    icon: "M2.686 4C2.257 3.6 2 3.04 2 2.4 2 1.04 3.114 0 4.571 0 5.43 0 6.971.72 8 1.68 9.029.72 10.571 0 11.429 0 12.886 0 14 1.04 14 2.4c0 .64-.257 1.2-.686 1.6H15a1 1 0 011 1v1H9V4H7v2H0V5a1 1 0 011-1h1.686zM1 8h6v7H2a1 1 0 01-1-1V8zm8 0h6v6a1 1 0 01-1 1H9V8zM4.77 3.2s2-.08 2.23-.16C6.615 2.56 5.23 1.6 4.77 1.6c-.462 0-.77.32-.77.8 0 .48.308.8.77.8zm6.46 0c.462 0 .77-.32.77-.8 0-.48-.308-.8-.77-.8-.46 0-1.768.88-2.23 1.44.23.08 2.23.16 2.23.16z",
    color: color,
    width: "16px",
    cursor: "pointer",
    display: "block",
    className: "clickable",
    height: "16px",
    viewBox: "0 0 16 16",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Gift a Subscription"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M2.686 4C2.257 3.6 2 3.04 2 2.4 2 1.04 3.114 0 4.571 0 5.43 0 6.971.72 8 1.68 9.029.72 10.571 0 11.429 0 12.886 0 14 1.04 14 2.4c0 .64-.257 1.2-.686 1.6H15a1 1 0 011 1v1H9V4H7v2H0V5a1 1 0 011-1h1.686zM1 8h6v7H2a1 1 0 01-1-1V8zm8 0h6v6a1 1 0 01-1 1H9V8zM4.77 3.2s2-.08 2.23-.16C6.615 2.56 5.23 1.6 4.77 1.6c-.462 0-.77.32-.77.8 0 .48.308.8.77.8zm6.46 0c.462 0 .77-.32.77-.8 0-.48-.308-.8-.77-.8-.46 0-1.768.88-2.23 1.44.23.08 2.23.16 2.23.16z",
    fill: color
  }));
};
var checkMarkIcon = function checkMarkIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Feature",
    icon: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
    color: color,
    width: "24px",
    cursor: "default",
    display: "block",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Feature"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
    fill: color
  }));
};
var eyeIcon = function eyeIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Show Password",
    icon: "M8.115 9.164C7.091 9.826 6.135 10.772 5.25 12c1.923 2.667 4.173 4 6.75 4s4.827-1.333 6.75-4c-.886-1.228-1.84-2.174-2.865-2.836.075.23.115.506.115.836a4 4 0 1 1-8 0c0-.33.04-.606.115-.836zM12 18c-3.314 0-6.314-2-9-6 2.686-4 5.686-6 9-6s6.314 2 9 6c-2.686 4-5.686 6-9 6zm-1-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Show"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M8.115 9.164C7.091 9.826 6.135 10.772 5.25 12c1.923 2.667 4.173 4 6.75 4s4.827-1.333 6.75-4c-.886-1.228-1.84-2.174-2.865-2.836.075.23.115.506.115.836a4 4 0 1 1-8 0c0-.33.04-.606.115-.836zM12 18c-3.314 0-6.314-2-9-6 2.686-4 5.686-6 9-6s6.314 2 9 6c-2.686 4-5.686 6-9 6zm-1-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: color
  }));
};
var eyeIconCrossed = function eyeIconCrossed(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Hide Password",
    icon: "M10.545 15.851c.473.1.958.149 1.455.149 2.577 0 4.827-1.333 6.75-4-.657-.912-1.353-1.667-2.086-2.267l-.686.685a4.001 4.001 0 0 1-3.56 3.56l-1.873 1.873zm7.412-7.411c1.055.924 2.07 2.11 3.043 3.56-2.686 4-5.686 6-9 6a8.03 8.03 0 0 1-3.017-.587l-2.149 2.15a1 1 0 0 1-1.414-1.415L18.148 5.42a1 1 0 1 1 1.414 1.414L17.957 8.44zM6.869 13.859l-1.282 1.282C4.694 14.286 3.832 13.24 3 12c2.686-4 5.686-6 9-6 .809 0 1.599.12 2.37.357L11.558 9.17a1 1 0 0 0-1.388 1.388L8.608 12.12A3.981 3.981 0 0 1 8 10c0-.33.04-.606.115-.836-1.024.662-1.98 1.608-2.865 2.836a12.54 12.54 0 0 0 1.619 1.859z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Hide"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M10.545 15.851c.473.1.958.149 1.455.149 2.577 0 4.827-1.333 6.75-4-.657-.912-1.353-1.667-2.086-2.267l-.686.685a4.001 4.001 0 0 1-3.56 3.56l-1.873 1.873zm7.412-7.411c1.055.924 2.07 2.11 3.043 3.56-2.686 4-5.686 6-9 6a8.03 8.03 0 0 1-3.017-.587l-2.149 2.15a1 1 0 0 1-1.414-1.415L18.148 5.42a1 1 0 1 1 1.414 1.414L17.957 8.44zM6.869 13.859l-1.282 1.282C4.694 14.286 3.832 13.24 3 12c2.686-4 5.686-6 9-6 .809 0 1.599.12 2.37.357L11.558 9.17a1 1 0 0 0-1.388 1.388L8.608 12.12A3.981 3.981 0 0 1 8 10c0-.33.04-.606.115-.836-1.024.662-1.98 1.608-2.865 2.836a12.54 12.54 0 0 0 1.619 1.859z",
    fill: color
  }));
};
var downIcon = function downIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Show details",
    icon: "M.787 3.312a.932.932 0 0 1 1.39 0l3.824 4.122 3.824-4.122a.931.931 0 0 1 1.39 0c.384.414.377 1.093-.006 1.507L6.702 9.688a.943.943 0 0 1-1.402 0L.793 4.819a1.125 1.125 0 0 1-.006-1.507z",
    color: color,
    width: "12px",
    cursor: "pointer",
    display: "block",
    className: "clickable",
    height: "12px",
    viewBox: "0 0 12 12",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Show details"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M.787 3.312a.932.932 0 0 1 1.39 0l3.824 4.122 3.824-4.122a.931.931 0 0 1 1.39 0c.384.414.377 1.093-.006 1.507L6.702 9.688a.943.943 0 0 1-1.402 0L.793 4.819a1.125 1.125 0 0 1-.006-1.507z",
    fill: color
  }));
};
var upIcon = function upIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Hide details",
    icon: "M.787 9.188a.932.932 0 0 0 1.39 0l3.824-4.122 3.824 4.122a.931.931 0 0 0 1.39 0c.384-.414.377-1.093-.006-1.507L6.702 2.812a.943.943 0 0 0-1.402 0L.793 7.681a1.125 1.125 0 0 0-.006 1.507z",
    color: color,
    width: "12px",
    cursor: "pointer",
    display: "block",
    className: "clickable",
    height: "12px",
    viewBox: "0 0 12 12",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Hide details"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M.787 9.188a.932.932 0 0 0 1.39 0l3.824-4.122 3.824 4.122a.931.931 0 0 0 1.39 0c.384-.414.377-1.093-.006-1.507L6.702 2.812a.943.943 0 0 0-1.402 0L.793 7.681a1.125 1.125 0 0 0-.006 1.507z",
    fill: color
  }));
};
var bankIcon = function bankIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    title: "Bank",
    icon: "M12.77 3.209l7.98 4.877c.279.17.333.49.12.714a.7.7 0 0 1-.505.2H3.635C3.285 9 3 8.772 3 8.49c0-.158.092-.308.25-.404l7.98-4.877a1.528 1.528 0 0 1 1.54 0zM6 10a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zM5 19h14a2 2 0 0 1 2 2H3a2 2 0 0 1 2-2z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Stripe Test Bank"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12.77 3.209l7.98 4.877c.279.17.333.49.12.714a.7.7 0 0 1-.505.2H3.635C3.285 9 3 8.772 3 8.49c0-.158.092-.308.25-.404l7.98-4.877a1.528 1.528 0 0 1 1.54 0zM6 10a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zM5 19h14a2 2 0 0 1 2 2H3a2 2 0 0 1 2-2z",
    fill: color
  }));
};
var addPaymentIcon = function addPaymentIcon(color) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    title: "Add Payment",
    icon: "M14.748 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-1.582c.63.256 1.301.433 2 .52V17a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-4c0-.69-.088-1.36-.252-2zm0 4H20v3h-6.755a7.973 7.973 0 0 0 1.503-3zM8 7V5a1 1 0 1 0-2 0v2H4a1 1 0 1 0 0 2h2v2a1 1 0 0 0 2 0V9h2a1 1 0 0 0 0-2H8zm8 8h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2zm-9-1A6 6 0 1 1 7 2a6 6 0 0 1 0 12z",
    color: color,
    cursor: "pointer",
    display: "block",
    width: "24px",
    className: "clickable",
    height: "24px",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": "svg-title",
    style: {
      cursor: 'pointer',
      display: 'block',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React__default['default'].createElement("title", {
    id: "svg-title"
  }, "Add Payment"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M14.748 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-1.582c.63.256 1.301.433 2 .52V17a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-4c0-.69-.088-1.36-.252-2zm0 4H20v3h-6.755a7.973 7.973 0 0 0 1.503-3zM8 7V5a1 1 0 1 0-2 0v2H4a1 1 0 1 0 0 2h2v2a1 1 0 0 0 2 0V9h2a1 1 0 0 0 0-2H8zm8 8h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2zm-9-1A6 6 0 1 1 7 2a6 6 0 0 1 0 12z",
    fill: color
  }));
};
var facebookIcon = function facebookIcon() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M24,12 C24,5.37257813 18.6274219,0 12,0 C5.37257813,0 0,5.37257813 0,12 C0,17.9895469 4.38822656,22.9539844 10.125,23.8542188 L10.125,15.46875 L7.078125,15.46875 L7.078125,12 L10.125,12 L10.125,9.35625 C10.125,6.34875 11.9165156,4.6875 14.6575781,4.6875 C15.9704766,4.6875 17.34375,4.921875 17.34375,4.921875 L17.34375,7.875 L15.8305781,7.875 C14.3398828,7.875 13.875,8.80000781 13.875,9.74899219 L13.875,12 L17.203125,12 L16.6710938,15.46875 L13.875,15.46875 L13.875,23.8542188 C19.6117734,22.9539844 24,17.9895469 24,12"
  }));
};
var appleIcon = function appleIcon() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    color: "white"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "icon_oauth_apple"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_oauth_apple",
    fill: "#000000"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M21.2773262,17.9239834 C20.9294975,18.7275393 20.5177816,19.4672078 20.040759,20.1472495 C19.3905314,21.0743188 18.8581403,21.7160283 18.447844,22.072376 C17.8118142,22.6572963 17.1303533,22.9568549 16.4006222,22.9738918 C15.8767494,22.9738918 15.2449782,22.8248216 14.5095686,22.5224248 C13.7717455,22.2214443 13.0936918,22.072376 12.4737043,22.072376 C11.8234771,22.072376 11.1261154,22.2214443 10.3801999,22.5224248 C9.63314778,22.8248216 9.03133307,22.9824103 8.57120482,22.9980272 C7.87142971,23.0278408 7.1739267,22.7197638 6.4777004,22.072376 C6.0333316,21.6847945 5.47751524,21.0203698 4.81167082,20.0791017 C4.097273,19.0739485 3.50993895,17.9083666 3.04981089,16.5795181 C2.55702957,15.1441911 2.31,13.754295 2.31,12.4086943 C2.31,10.8673152 2.64306401,9.53789866 3.31018572,8.42385203 C3.83448462,7.52900931 4.53198814,6.82312926 5.40496745,6.3049348 C6.27794753,5.78674111 7.22120292,5.5226751 8.23700571,5.50578018 C8.79282168,5.50578018 9.52170139,5.67770709 10.4274761,6.01559818 C11.3306957,6.35462494 11.9106474,6.52655185 12.164917,6.52655185 C12.3550162,6.52655185 12.9992806,6.32552054 14.0914636,5.92473695 C15.1243032,5.55305679 15.9960048,5.39915969 16.7101189,5.45978125 C18.645184,5.61594948 20.098967,6.37875988 21.0657897,7.75303912 C19.3351633,8.80163713 18.479078,10.270327 18.4961143,12.154424 C18.5117312,13.621978 19.0441222,14.8432124 20.0904485,15.812875 C20.5646314,16.2629224 21.0941837,16.6107514 21.6833619,16.8577813 C21.5555898,17.2283254 21.4207173,17.583253 21.2773262,17.9239834 Z M16.839313,0.460130955 C16.839313,1.61039356 16.4190782,2.68439048 15.5814498,3.6784709 C14.5706155,4.86023806 13.3479619,5.54311826 12.0220943,5.43536249 C12.0052,5.29736646 11.9954039,5.15213041 11.9954039,4.99951176 C11.9954039,3.89526088 12.4761178,2.7134943 13.3297899,1.74723958 C13.7559861,1.2580079 14.2980315,0.851218376 14.9553574,0.526714662 C15.6112633,0.207052737 16.2316768,0.0302728073 16.8151771,0 C16.8322148,0.15377214 16.839313,0.307553959 16.839313,0.460116038 L16.839313,0.460130955 Z",
    id: "Shape",
    fill: "white"
  }))));
};
var githubIcon = function githubIcon() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    color: "white"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "icon_oauth_github"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_oauth_github",
    fill: "#151513"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12,1.77635684e-15 C5.3735,1.77635684e-15 0,5.3725 0,12 C0,17.302 3.4385,21.8 8.2065,23.387 C8.8065,23.498 9.0265,23.127 9.0265,22.8095 C9.0265,22.5235 9.015,21.578 9.01,20.5755 C5.6715,21.3015 4.967,19.1595 4.967,19.1595 C4.421,17.7725 3.6345,17.404 3.6345,17.404 C2.546,16.659 3.717,16.674 3.717,16.674 C4.922,16.759 5.5565,17.911 5.5565,17.911 C6.6265,19.7455 8.3635,19.215 9.0485,18.9085 C9.156,18.133 9.467,17.6035 9.81,17.3035 C7.145,17.0005 4.343,15.9715 4.343,11.3735 C4.343,10.0635 4.8115,8.9925 5.5795,8.1525 C5.4545,7.85 5.044,6.6295 5.6955,4.9765 C5.6955,4.9765 6.7035,4.654 8.9965,6.2065 C9.9535,5.941 10.9805,5.8075 12,5.803 C13.02,5.8075 14.0475,5.941 15.0065,6.2065 C17.2965,4.654 18.303,4.9765 18.303,4.9765 C18.956,6.6295 18.545,7.85 18.4205,8.1525 C19.1905,8.9925 19.6555,10.063 19.6555,11.3735 C19.6555,15.9825 16.8485,16.997 14.176,17.2945 C14.6065,17.6665 14.99,18.397 14.99,19.5165 C14.99,21.122 14.9765,22.4145 14.9765,22.8095 C14.9765,23.1295 15.1925,23.503 15.8005,23.3855 C20.566,21.797 24,17.3 24,12 C24,5.372 18.6275,1.77635684e-15 12,1.77635684e-15",
    id: "Shape",
    fill: "white"
  }))));
};
var linkedinIcon = function linkedinIcon() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    color: "white"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "icon_oauth_linkedin"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_oauth_linkedin",
    fill: "#0A66C2"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M22.08,0 L2.05,0 C0.957,0 2.13162821e-14,0.787 2.13162821e-14,1.869 L2.13162821e-14,21.943 C2.13162821e-14,23.031 0.957,24 2.05,24 L22.075,24 C23.175,24 24.0000323,23.025 24.0000323,21.943 L24.0000323,1.869 C24.006,0.788 23.175,0 22.081,0 L22.08,0 Z M7.44,20.005 L4.001,20.005 L4.001,9.315 L7.439,9.315 L7.44,20.005 Z M5.839,7.69 L5.814,7.69 C4.714,7.69 4.001,6.871 4.001,5.846 C4.001,4.801 4.732,4.001 5.858,4.001 C6.983,4.001 7.671,4.795 7.696,5.846 C7.696,6.871 6.983,7.69 5.839,7.69 Z M20.005,20.005 L16.567,20.005 L16.567,14.16 C16.567,12.76 16.067,11.803 14.822,11.803 C13.872,11.803 13.31,12.447 13.06,13.072 C12.966,13.297 12.941,13.604 12.941,13.916 L12.941,20.005 L9.502,20.005 L9.502,9.315 L12.941,9.315 L12.941,10.803 C13.441,10.09 14.222,9.065 16.041,9.065 C18.299,9.065 20.005,10.553 20.005,13.76 L20.005,20.005 L20.005,20.005 Z",
    id: "Shape",
    fill: "white"
  }))));
};
var twitterIcon = function twitterIcon() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    color: "white"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "icon_oauth_twitter"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Brands",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "icon_oauth_twitter",
    fill: "#1DA1F2"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M7.54752,21.7514103 C16.60416,21.7514103 21.55776,14.2480503 21.55776,7.74117027 C21.55776,7.52805027 21.55776,7.31589027 21.54336,7.10469027 C22.5070381,6.40764469 23.3389013,5.54457449 24,4.55589027 C23.1013239,4.95409997 22.1479961,5.21524577 21.17184,5.33061027 C22.1997542,4.71523304 22.9690786,3.74735138 23.33664,2.60709027 C22.3700712,3.18064737 21.3126203,3.58486181 20.20992,3.80229027 C18.6835995,2.17930878 16.2582906,1.78207835 14.2939673,2.833343 C12.329644,3.88460765 11.314824,6.12292297 11.81856,8.29317027 C7.85941991,8.09468983 4.17069675,6.22468061 1.6704,3.14853027 C0.363477846,5.39842921 1.03102837,8.27671537 3.19488,9.72165027 C2.41127155,9.69842552 1.6447482,9.48703892 0.96,9.10533027 C0.96,9.12549027 0.96,9.14661027 0.96,9.16773027 C0.960641408,11.5116595 2.61288143,13.530484 4.9104,13.9946103 C4.18547481,14.1923127 3.42487736,14.2212128 2.68704,14.0790903 C3.33211001,16.0849362 5.18071158,17.4590428 7.28736,17.4986103 C5.54374564,18.8689449 3.38981713,19.6128449 1.17216,19.6106103 C0.780387426,19.6098582 0.388995903,19.5861375 0,19.5395703 C2.25181051,20.9846358 4.87191687,21.7511385 7.54752,21.7475703",
    id: "Path",
    fill: "white"
  }))));
};
var googleIcon = function googleIcon() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    height: "24px",
    width: "24px"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "google_logo"), /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M482.56 261.36c0-16.73-1.5-32.83-4.29-48.27H256v91.29h127.01c-5.47 29.5-22.1 54.49-47.09 71.23v59.21h76.27c44.63-41.09 70.37-101.59 70.37-173.46z",
    fill: "#4285f4"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M256 492c63.72 0 117.14-21.13 156.19-57.18l-76.27-59.21c-21.13 14.16-48.17 22.53-79.92 22.53-61.47 0-113.49-41.51-132.05-97.3H45.1v61.15c38.83 77.13 118.64 130.01 210.9 130.01z",
    fill: "#34a853"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M123.95 300.84c-4.72-14.16-7.4-29.29-7.4-44.84s2.68-30.68 7.4-44.84V150.01H45.1C29.12 181.87 20 217.92 20 256c0 38.08 9.12 74.13 25.1 105.99l78.85-61.15z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M256 113.86c34.65 0 65.76 11.91 90.22 35.29l67.69-67.69C373.03 43.39 319.61 20 256 20c-92.25 0-172.07 52.89-210.9 130.01l78.85 61.15c18.56-55.78 70.59-97.3 132.05-97.3z",
    fill: "#ea4335"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20 20h472v472H20V20z"
  })));
};

var getSvgImage = function getSvgImage() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '444';
  var iconType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'question-mark-icon';

  switch (iconType) {
    case 'user-icon':
      return userIcon(color);

    case 'envelope-icon':
      return envelopeIcon(color);

    case 'refresh-icon':
      return refreshIcon(color);

    case 'question-mark-icon':
      return questionMarkIcon(color);

    case 'logout-icon':
      return logoutIcon(color);

    case 'edit-icon':
      return editIcon(color);

    case 'trash-icon':
      return trashIcon(color);

    case 'switch-plan':
      return switchPlan(color);

    case 'update-payment':
      return paymentMethod(color);

    case 'close-icon':
      return closeIcon(color);

    case 'pico-icon':
      return picoIcon();

    case 'back-icon':
      return backIcon(color);

    case 'keep-icon':
      return keepIcon(color);

    case 'gift-icon':
      return giftIcon(color);

    case 'check-icon':
      return checkMarkIcon(color);

    case 'eye-icon':
      return eyeIcon(color);

    case 'eye-icon-crossed':
      return eyeIconCrossed(color);

    case 'up-icon':
      return upIcon(color);

    case 'down-icon':
      return downIcon(color);

    case 'bank-icon':
      return bankIcon(color);

    case 'add-payment-icon':
      return addPaymentIcon(color);

    case 'facebook-icon':
      return facebookIcon();

    case 'apple-icon':
      return appleIcon();

    case 'github-icon':
      return githubIcon();

    case 'linkedin-icon':
      return linkedinIcon();

    case 'twitter-icon':
      return twitterIcon();

    case 'google-icon':
      return googleIcon();

    default:
      return null;
  }
};

var inIframe = function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

var pad2 = function pad2(c) {
  return c.length === 1 ? "0".concat(c) : "".concat(c);
};

var rgbToHex = function rgbToHex(rgb) {
  var hex = [pad2(Math.round(rgb.r).toString(16)), pad2(Math.round(rgb.g).toString(16)), pad2(Math.round(rgb.b).toString(16))];

  if (hex[0].charAt(0) === hex[0].charAt(1) && hex[1].charAt(0) === hex[1].charAt(1) && hex[2].charAt(0) === hex[2].charAt(1)) {
    var hexString = hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);

    if (hexString.length === 3) {
      hexString += hexString;
    }

    return hexString;
  }

  return hex.join('');
};

var utmLink = function utmLink() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$utmCampaign = _ref.utmCampaign,
      utmCampaign = _ref$utmCampaign === void 0 ? null : _ref$utmCampaign,
      _ref$utmSource = _ref.utmSource,
      utmSource = _ref$utmSource === void 0 ? null : _ref$utmSource,
      _ref$utmMedium = _ref.utmMedium,
      utmMedium = _ref$utmMedium === void 0 ? null : _ref$utmMedium,
      _ref$utmContent = _ref.utmContent,
      utmContent = _ref$utmContent === void 0 ? null : _ref$utmContent,
      _ref$rootUrl = _ref.rootUrl,
      rootUrl = _ref$rootUrl === void 0 ? '' : _ref$rootUrl;

  var queryString = qs__default['default'].stringify({
    utm_campaign: utmCampaign,
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_content: utmContent
  }, {
    skipNulls: true
  });
  var trypico_link = "".concat(rootUrl, "/?").concat(queryString);
  var terms_link = "".concat(rootUrl, "/terms/member-agreement/?").concat(queryString);
  return {
    trypico_link: trypico_link,
    terms_link: terms_link
  };
};

var RGB = {
  toHEX: function toHEX(_ref) {
    var r = _ref.r,
        g = _ref.g,
        b = _ref.b;
    return '#' + [r, g, b].map(function (x) {
      var hex = x.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    }).join('');
  },
  toHSL: function toHSL(_ref2) {
    var r = _ref2.r,
        g = _ref2.g,
        b = _ref2.b;
    var red = r / 255;
    var green = g / 255;
    var blue = b / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var hue, saturation;
    var lightness = (max + min) / 2;

    if (max === min) {
      hue = 0;
      saturation = 0;
    } else {
      var range = max - min;
      saturation = range / (1 - Math.abs(2 * lightness - 1));

      switch (max) {
        case red:
          hue = (green - blue) / range % 6;
          break;

        case green:
          hue = (blue - red) / range + 2;
          break;

        case blue:
          hue = (red - green) / range + 4;
          break;

        default:
          hue = (max + min) / 2;
          break;
      }

      hue = Math.round(hue * 60);
      saturation = +(saturation * 100).toFixed(1);
      lightness = +(lightness * 100).toFixed(1);
    }

    return {
      h: hue,
      s: saturation,
      l: lightness
    };
  },
  saturate: function saturate(rgb) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    return HSL.toRGB(HSL.saturate(RGB.toHSL(rgb), amount));
  },
  desaturate: function desaturate(rgb) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    return HSL.toRGB(HSL.desaturate(RGB.toHSL(rgb), amount));
  },
  darken: function darken(rgb) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    return HSL.toRGB(HSL.darken(RGB.toHSL(rgb), amount));
  },
  lighten: function lighten(rgb) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    return HSL.toRGB(HSL.lighten(RGB.toHSL(rgb), amount));
  }
};

var HSL = {
  toRGB: function toRGB(_ref) {
    var h = _ref.h,
        s = _ref.s,
        l = _ref.l;
    var red, green, blue;
    var saturation = s / 100;
    var lightness = l / 100;

    if (saturation === 0) {
      red = green = blue = l; // achromatic

      return {
        r: red,
        g: green,
        b: blue
      };
    } else {
      var c = (1 - Math.abs(2 * lightness - 1)) * saturation;
      var x = c * (1 - Math.abs(h / 60 % 2 - 1));
      var m = lightness - c / 2,
          _red = 0,
          _green = 0,
          _blue = 0;

      if (0 <= h && h < 60) {
        _red = c;
        _green = x;
        _blue = 0;
      } else if (60 <= h && h < 120) {
        _red = x;
        _green = c;
        _blue = 0;
      } else if (120 <= h && h < 180) {
        _red = 0;
        _green = c;
        _blue = x;
      } else if (180 <= h && h < 240) {
        _red = 0;
        _green = x;
        _blue = c;
      } else if (240 <= h && h < 300) {
        _red = x;
        _green = 0;
        _blue = c;
      } else if (300 <= h && h < 360) {
        _red = c;
        _green = 0;
        _blue = x;
      }

      _red = Math.round((_red + m) * 255);
      _green = Math.round((_green + m) * 255);
      _blue = Math.round((_blue + m) * 255);
      return {
        r: _red,
        g: _green,
        b: _blue
      };
    }
  },
  toHEX: function toHEX(hsl) {
    return RGB.toHEX(HSL.toRGB(hsl));
  },
  saturate: function saturate(hsl) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    hsl.s += amount;
    hsl.s = Math.min(100, Math.max(0, hsl.s));
    return hsl;
  },
  desaturate: function desaturate(hsl) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    hsl.s -= amount;
    hsl.s = Math.min(100, Math.max(0, hsl.s));
    return hsl;
  },
  darken: function darken(hsl) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    hsl.l -= amount;
    hsl.l = Math.min(100, Math.max(0, hsl.l));
    return hsl;
  },
  lighten: function lighten(hsl) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    hsl.l += amount;
    hsl.l = Math.min(100, Math.max(0, hsl.l));
    return hsl;
  }
};

var HEX = {
  toHSL: function toHSL(hex) {
    return RGB.toHSL(HEX.toRGB(hex));
  },
  toRGB: function toRGB(hex, alpha) {
    if (alpha) {
      var _HEX$toRGB = HEX.toRGB(hex),
          r = _HEX$toRGB.r,
          g = _HEX$toRGB.g,
          b = _HEX$toRGB.b;

      return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
    } else {
      var rgb = parseInt(hex.substring(1), 16); // strip # and convert rrggbb to decimal

      var red = rgb >> 16 & 0xff; // extract red

      var green = rgb >> 8 & 0xff; // extract green

      var blue = rgb >> 0 & 0xff; // extract blue

      return {
        r: red,
        g: green,
        b: blue
      };
    }
  },
  saturate: function saturate(hex) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    return HSL.toHEX(HSL.saturate(HEX.toHSL(hex), amount));
  },
  desaturate: function desaturate(hex) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    return HSL.toHEX(HSL.desaturate(HEX.toHSL(hex), amount));
  },
  darken: function darken(hex) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    return HSL.toHEX(HSL.darken(HEX.toHSL(hex), amount));
  },
  lighten: function lighten(hex) {
    var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    return HSL.toHEX(HSL.lighten(HEX.toHSL(hex), amount));
  }
};

var WHITE = '#FFFFFF';
var DARK_GRAY = '#444444';
var hexToRgba = function hexToRgba(hex, a) {
  return HEX.toRGB(hex, a);
};
var hexToRgb = function hexToRgb() {
  var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return HEX.toRGB(hex);
};

var getBrightness = function getBrightness(hex) {
  var _HEX$toRGB = HEX.toRGB(hex),
      r = _HEX$toRGB.r,
      g = _HEX$toRGB.g,
      b = _HEX$toRGB.b;

  return (r * 299 + g * 587 + b * 114) / 1000;
};

var filterColor = function filterColor(hex, filter) {
  if (isDark(hex, 176)) {
    return HEX.lighten(hex, filter);
  } else {
    return HEX.darken(hex, filter);
  }
};
var isDark = function isDark(hex, threshold) {
  return getBrightness(hex) < threshold;
};
var getContrastColor = function getContrastColor(hex) {
  return isDark(hex, 176) ? WHITE : DARK_GRAY;
};
var getHoverColor = function getHoverColor(hex) {
  return HEX.saturate(filterColor(hex, 5), 2);
};
var getActiveColor = function getActiveColor(hex) {
  return filterColor(hex, 10);
};
var getBgColor = function getBgColor(hex, alpha, returnObject) {
  var _HEX$toRGB2 = HEX.toRGB(hex),
      r = _HEX$toRGB2.r,
      g = _HEX$toRGB2.g,
      b = _HEX$toRGB2.b;

  var lightR = Math.round((1 - alpha) * 255 + alpha * r);
  var lightG = Math.round((1 - alpha) * 255 + alpha * g);
  var lightB = Math.round((1 - alpha) * 255 + alpha * b);
  return returnObject ? {
    r: lightR,
    g: lightG,
    b: lightB
  } : "rgb(".concat(lightR, ", ").concat(lightG, ", ").concat(lightB, ")");
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  hexToRgba: hexToRgba,
  hexToRgb: hexToRgb,
  filterColor: filterColor,
  isDark: isDark,
  getContrastColor: getContrastColor,
  getHoverColor: getHoverColor,
  getActiveColor: getActiveColor,
  getBgColor: getBgColor
});

exports.AnnualPercentDiscount = calculateAnnualPercentDiscount;
exports.Capitalize = capitalize;
exports.InFrame = inIframe;
exports.colors = index;
exports.getSvgImage = getSvgImage;
exports.rgbToHex = rgbToHex;
exports.utmLink = utmLink;
